import React from 'react';
import { TabProps } from '../types';
import { Icon, Header, Grid } from 'semantic-ui-react';
import { DesignSystem } from '../../../styles/designSystem';

const AddressTab: React.FC<TabProps> = ({ data }) => {
  return (
    <div style={{
      padding: '1rem',
      background: DesignSystem.colors.section.gradient,
      minHeight: '30vh'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '10px',
        padding: '1rem',
        boxShadow: '0 8px 15px rgba(0,0,0,0.08)',
        border: '1px solid rgba(255,255,255,0.8)'
      }}>
        <Header as="h2" style={{
          color: '#2c3e50',
          textAlign: 'center',
          marginBottom: '1rem',
          fontWeight: '700',
          fontSize: '1.3rem'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #e74c3c, #c0392b)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            <Icon name="map marker alternate" size="large" />
            Endereço e Contato
          </div>
        </Header>

        {/* Endereço principal */}
        <div style={{
          background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
          borderRadius: '8px',
          padding: '1rem',
          marginBottom: '1rem',
          boxShadow: '0 4px 10px rgba(0,0,0,0.04)',
          border: '1px solid rgba(231, 76, 60, 0.08)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
            <div style={{
              background: 'linear-gradient(135deg, #e74c3c, #c0392b)',
              borderRadius: '50%',
              padding: '0.5rem',
              color: 'white',
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Icon name="map" />
            </div>
            <div>
              <div style={{
                color: '#7f8c8d',
                fontSize: '0.7rem',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '0.3px'
              }}>
                Endereço Completo
              </div>
              <div style={{
                color: '#2c3e50',
                fontSize: '0.95rem',
                fontWeight: '600',
                marginTop: '0.15rem'
              }}>
                {data.logradouro}, {data.numero}
                {data.complemento && ` - ${data.complemento}`}
              </div>
            </div>
          </div>
        </div>

        <Grid columns={2} stackable>
          {[
            { label: 'Bairro', value: data.bairro, icon: 'map signs' },
            { label: 'CEP', value: data.cep, icon: 'envelope' },
            { label: 'Cidade', value: data.cidade || data.municipio, icon: 'building' },
            { label: 'Estado', value: data.estado || data.uf, icon: 'flag' },
            { label: 'Email', value: data.email, icon: 'mail' },
            { label: 'Telefone', value: data.telefone || data.telefone1, icon: 'phone' }
          ].map((item, index) => (
            <Grid.Column key={index}>
              <div style={{
                background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
                borderRadius: '8px',
                padding: '0.75rem',
                marginBottom: '0.5rem',
                boxShadow: '0 3px 8px rgba(0,0,0,0.04)',
                border: '1px solid rgba(231, 76, 60, 0.08)',
                transition: 'transform 0.2s ease',
                cursor: 'default'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.08)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 3px 8px rgba(0,0,0,0.04)';
              }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #e74c3c, #c0392b)',
                    borderRadius: '50%',
                    padding: '0.3rem',
                    color: 'white',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Icon name={item.icon as any} size="tiny" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      color: '#7f8c8d',
                      fontSize: '0.7rem',
                      fontWeight: '600',
                      textTransform: 'uppercase',
                      letterSpacing: '0.3px'
                    }}>
                      {item.label}
                    </div>
                    <div style={{
                      color: '#2c3e50',
                      fontSize: '0.9rem',
                      fontWeight: '500',
                      marginTop: '0.15rem'
                    }}>
                      {item.value || 'Não informado'}
                    </div>
                  </div>
                </div>
              </div>
            </Grid.Column>
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default AddressTab;
